import {serverSideTranslations} from 'next-i18next/serverSideTranslations';
import HeaderAppyShop, {getComponentStaticProps, HeaderProps} from '../../components/header/headerAppyShop'
import styles from './cart.module.scss'
import FooterAppyShop from '../../components/footer/footerAppyShop';
import {GetStaticProps} from 'next';
import {useTranslation} from 'next-i18next';
import {CurrentOrder, Customer, ShopState} from '../../interfaces/store-interfaces';
import {connect, useSelector} from 'react-redux';
import Link from 'next/link';
import {checkCartAvailability, deleteOrderId, downloadAQuote} from '../../services/cart-services';
import {useEffect, useState} from 'react';
import {CartResponseDTO} from "../../interfaces/cart-interfaces";
import Price from '../../components/price/price';
import {
    addPromoCode,
    updateNbItemsOnCart,
    deletePromoCode,
    updateCartWithQuantityAvailable,
    resetCurrentOrderToStep1
} from '../../store/action';
import NbItemsOnCart from '../../components/shoppingCart/nbItemsOnCart/nbItemsOnCart'
import OrderSummary from '../../components/shoppingCart/orderSummary/orderSummary';
import Loader from '../../components/loader/loader'
import {toast} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css';
import {config} from '../../config-merchant';
import Meta from '../../components/meta/meta';
import {appyShopConfig} from '../../config';
import _variables from '../../styles/global.module.scss'
import ModalShop from "../../components/modal/modal";
import {useRouter} from "next/router";

function Cart(props: {
    headerProps: HeaderProps,
    nbItemsOnCart: number,
    currentCurrency: string,
    shoppingCart: {},
    updateNbItemsOnCart: any,
    promoCode: string,
    addPromoCode: any,
    deletePromoCode: any,
    updateCartWithQuantityAvailable: any,
    resetCurrentOrderToStep1: any,
    currentOrder: CurrentOrder
}) {

    const mapCartStoreToProducts = () => {
        const products: { productId: number, quantity: number }[] = [];
        Object.entries(props.shoppingCart).forEach(product => products.push({
            "productId": +product[0],
            "quantity": product[1]["quantity"]
        }))
        return products;
    }

    const {t} = useTranslation('common');
    const {i18n} = useTranslation('common')
    const router = useRouter();

    const [cartAvail, setCartAvail] = useState<CartResponseDTO>({
        products: [],
        promoCodeApplied: null,
        totals: {totalTax: 0, totalWithTax: 0, totalWithoutTax: null},
        totalsBeforePromo: null,
        deliveryPrice: null,
        subTotals: {totalTax: null, totalWithTax: 0, totalWithoutTax: null},
        promoCode: null,
        currency: null,
        language: null
    });
    const [products, setProducts] = useState<{ productId: number, quantity: number }[]>(mapCartStoreToProducts);
    const [promoCodeInput, setPromoCodeInput] = useState<string>("");
    const [isLoading, setLoading] = useState<boolean>(true);
    const [isModalQuoteOpen, setModalQuoteOpen] = useState<boolean>(false);
    const [isQuoteLoading, setQuoteLoading] = useState<boolean>(false);

    const customer: Customer = useSelector((state: ShopState) => state.customer);

    const options = {
        autoClose: 6000,
        type: toast.TYPE.ERROR,
        position: toast.POSITION.TOP_CENTER,
    };

    const checkShoppingCart = async () => {
        setLoading(true);
        if (props.currentOrder.orderTimeout !== null && props.currentOrder.orderTimeout > Date.now()) {
            try {
                await deleteOrderId(props.currentOrder.orderId)
            } catch (e) {
                console.log(e)
            }
        }
        props.resetCurrentOrderToStep1();
        try {
            const cart = await checkCartAvailability(i18n.language.toUpperCase(), props.currentCurrency, products, props.promoCode);
            const cartData: CartResponseDTO = cart['data'];
            cartData['products'] = cartData.products.filter(product => !product.error);
            setCartAvail(cartData);

        } catch (e) {
            toast(t('TOAST_UNEXPECTED_ERROR'), options);
        }
        setLoading(false);
    }

    const plusMinusQtProduct = (idP: number, action: string) => {
        const newProducts = products;
        if (action === '+') {
            newProducts.map(product => product.productId === idP ? (product.quantity += 1) : null);
        } else {
            const isQuantityAvailable: boolean = cartAvail.products.find(product => product.productId === idP).requestedQuantityAvailable;
            const quantityMax: number = cartAvail.products.find(product => product.productId === idP).quantity;
            newProducts.map(product => product.productId === idP ? (isQuantityAvailable ? product.quantity -= 1 : product.quantity = quantityMax - 1) : null);
        }
        setProducts(newProducts);
        /* doesn't trigger useEffect for products here , to fix */
        checkShoppingCart();
    }

    const removeProduct = (idP: number) => {
        const newProducts = products.filter(product => product.productId !== idP);
        setProducts(newProducts);
    }

    const isThereOnlyItemAt0 = () => {
        const nbProductTo0 = cartAvail.products.filter(product => product.quantity === 0).length;
        const nbProductNot0 = cartAvail.products.filter(product => product.quantity > 0).length;
        return nbProductTo0 >= 1 && nbProductNot0 === 0;
    }

    const downloadQuote = () => {
        if (customer !== undefined && customer !== null) {
            setQuoteLoading(true);
            downloadAQuote(i18n.language.toUpperCase(), props.currentCurrency, products, props.promoCode, customer.jwt)
                .then(r => {
                    setTimeout(() => window.open(r.data, '_blank').focus(), 200);
                    setQuoteLoading(false);
                })
                .catch(err => {
                    toast(t('TOAST_UNEXPECTED_ERROR'), options);
                    setQuoteLoading(false);
                });
        } else {
            setModalQuoteOpen(true);
        }
    }

    useEffect(() => {
        checkShoppingCart();
        isThereOnlyItemAt0();
    }, [props.promoCode])

    useEffect(() => {
        checkShoppingCart();
    }, [props.currentCurrency])

    useEffect(() => {
        checkShoppingCart();
    }, [products])

    useEffect(() => {
        props.updateNbItemsOnCart(cartAvail.products.reduce((acc, product) => acc + product.quantity, 0));
        props.updateCartWithQuantityAvailable(cartAvail.products);
    }, [cartAvail])


    return (
        <>
            <Meta
                title={t('NAV_CART')}
                description={config.shopSlogan[i18n.language]}
                image={config.merchantDomain + config.defaultMetaImage}
                metaRobots={true}
            />
            <HeaderAppyShop headerProps={props.headerProps}/>
            <main>
                {/* <!--For Shopping Cart--> */}
                <div className={styles["shopping-cart"]}>
                    {/* <!--Title--> */}
                    <NbItemsOnCart nbItems={props.nbItemsOnCart} key={props.nbItemsOnCart}/>
                    <div className={styles["layout-row"]}>

                        {/* <!--Right column--> */}
                        {
                            (cartAvail.products.length > 0 && !isThereOnlyItemAt0()) &&
                            <OrderSummary
                                key={props.currentCurrency + cartAvail.totals.totalTax}
                                cartAvail={cartAvail}
                                page={'cart'}
                                vatEnabled={true}
                                checkShoppingCart={checkShoppingCart}
                                nbItemsOnCart={props.nbItemsOnCart}
                                addPromoCode={() => props.addPromoCode(promoCodeInput)}
                                promoCode={props.promoCode}
                                setPromoCodeInput={setPromoCodeInput}
                                deletePromoCode={props.deletePromoCode}
                                isLoading={isLoading}
                            />
                        }
                        <div className={styles["loader-place"]}>{isLoading && <Loader/>}</div>
                        {/* <!--Left column--> */}
                        <div className={`${styles['layout-column-left']} ${styles['cart']}`}>

                            {
                                !isLoading && cartAvail.products.length === 0 ?
                                    <div className={styles['empty-cart']}>
                                        <img src={"/assets/images/cart-empty.png"}/>
                                        <p>{t('CART_EMPTY')}</p>
                                    </div>

                                    : cartAvail.products.map(product =>
                                        <div className={styles["cart-item"]} key={product.productId}>
                                            <div className={styles["infos"]}>
                                                <div className={styles["image"]}>
                                                    <Link href={`/product/${product.productSlug}`}><img src={product.image}
                                                                                                        alt={product.name}/></Link>
                                                </div>
                                                <div className={styles["item"]}>
                                                    <Link href={`/product/${product.productSlug}`}><p
                                                        className={styles["product"]}>{product.name}</p></Link>
                                                    <Price price={product.price.amountWithTax} page={'cart'}
                                                           key={props.currentCurrency}/>
                                                    {
                                                        !product.requestedQuantityAvailable &&
                                                        <div className={styles["not-enough-item"]}>
                                                            <p>{t('CART_QUANTITY_MAX')}</p>
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                            <div className={styles["actions"]}>
                                                <div className={styles["stock-wrapper"]}>
                                                    <button className={styles["plusminus"]}
                                                            onClick={() => product.quantity <= 1 ? removeProduct(product.productId) : plusMinusQtProduct(product.productId, '-')}>-
                                                    </button>
                                                    <input value={product.quantity} type="number" min="1" max="100"
                                                           disabled/>
                                                    <button
                                                        className={product.requestedQuantityAvailable ? styles["plusminus"] : styles['plusminusdisabled']}
                                                        onClick={() => product.requestedQuantityAvailable ? plusMinusQtProduct(product.productId, '+') : null}>+
                                                    </button>
                                                </div>
                                                <div className={`${styles['remove']} ${styles['tooltip']}`}
                                                     onClick={() => removeProduct(product.productId)}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="51.833" height="54.627"
                                                         viewBox="0 0 51.833 54.627">
                                                        <g transform="translate(-826.185 -631.373)">
                                                            <path
                                                                d="M7.867,5.911H35.244A1.956,1.956,0,0,1,37.2,7.867V35.244A1.956,1.956,0,0,1,35.244,37.2H7.867a1.956,1.956,0,0,1-1.956-1.956V7.867A1.956,1.956,0,0,1,7.867,5.911ZM2,7.867A5.867,5.867,0,0,1,7.867,2H35.244a5.867,5.867,0,0,1,5.867,5.867V35.244a5.867,5.867,0,0,1-5.867,5.867H7.867A5.867,5.867,0,0,1,2,35.244ZM21.555,21.555c-5.4,0-9.778-5.253-9.778-11.733h3.911c0,5.018,3.264,7.822,5.867,7.822s5.867-2.8,5.867-7.822h3.911C31.333,16.3,26.955,21.555,21.555,21.555Z"
                                                                transform="translate(824.185 629.373)"
                                                                fill={_variables.colorBase} fillRule="evenodd"/>
                                                            <g transform="translate(857.473 644.912) rotate(45)">
                                                                <ellipse cx="12.851" cy="13.409" rx="12.851" ry="13.409"
                                                                         transform="translate(1.676 1.117)"
                                                                         fill={_variables.mainColor}/>
                                                                <path
                                                                    d="M2,16.527A14.527,14.527,0,1,1,16.527,31.054,14.527,14.527,0,0,1,2,16.527ZM16.527,4.905A11.622,11.622,0,1,0,28.148,16.527,11.622,11.622,0,0,0,16.527,4.905Z"
                                                                    transform="translate(-2 -2)" fill={_variables.mainColor}
                                                                    fillRule="evenodd"/>
                                                                <path
                                                                    d="M17.733,7.676a1.676,1.676,0,0,0-3.352,0v6.7h-6.7a1.676,1.676,0,0,0,0,3.352h6.7v6.7a1.676,1.676,0,1,0,3.352,0v-6.7h6.7a1.676,1.676,0,1,0,0-3.352h-6.7Z"
                                                                    transform="translate(-1.53 -1.53)"
                                                                    fill={_variables.bagSvgCrossColor} fillRule="evenodd"/>
                                                            </g>
                                                        </g>
                                                    </svg>
                                                    <span className={styles["tooltiptext"]}>{t('CART_REMOVE_ITEM')}</span>
                                                </div>
                                            </div>
                                        </div>
                                    )
                            }
                            {
                                isModalQuoteOpen &&
                                <ModalShop
                                    closePopup={() => setModalQuoteOpen(false)}
                                    actionbutton1={() => setModalQuoteOpen(false)}
                                    actionbutton2={() => router.push(`/login?redirect=cart`)}
                                    modalText={{
                                        title: t('CART_ASK_QUOTE_MODAL_TITLE'),
                                        subtitle: t('CART_ASK_QUOTE_MODAL_SUBTITLE'),
                                        question: t('PRODUCT_NEXT_ACTION'),
                                        button1: t('CART_ASK_QUOTE_MODAL_BUTTON_1'),
                                        button2: t('CART_ASK_QUOTE_MODAL_BUTTON_2')
                                    }}
                                />
                            }
                            {
                                config.quoteDownloadEnabled && cartAvail.products.length > 0 &&
                                <div>
                                    {
                                        isQuoteLoading ? (
                                            <Loader/>
                                        ) : (
                                            <a
                                                className={`${styles['button']} ${styles['submit']}`}
                                                onClick={downloadQuote}
                                            >
                                                <p>{t('CART_ASK_QUOTE')}</p>
                                            </a>
                                        )
                                    }
                                </div>
                            }
                            {/* <!--Button continue shopping--> */}
                            <Link href='/catalog'>
                                <div className={styles["button-continue"]}>
                                    <p>&lsaquo; {t('CART_CONTINUE_SHOPPING')}</p>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </main>
            <FooterAppyShop/>
        </>
    );
}

export const getStaticProps: GetStaticProps = async ({locale}) => {
    if (config.menu.some(item => item.path === 'catalog') || config.footerLink.some(item => item.url === '/catalog')) {
        return {
            props: {
                ...await serverSideTranslations(locale, ['common']),
                headerProps: await getComponentStaticProps(locale)
            },
            revalidate: appyShopConfig.revalidateData
        }
    } else {
        return {
            notFound: true
        }
    }
}

const mapState = (state: ShopState) => ({
    nbItemsOnCart: state.nbItemsOnCart,
    currentCurrency: state.currentCurrency,
    shoppingCart: state.shoppingCart,
    promoCode: state.promoCode,
    currentOrder: state.currentOrder
})

const mapDispatch = (dispatch) => {
    return {
        updateNbItemsOnCart: (nbItems: number) => dispatch(updateNbItemsOnCart(nbItems)),
        addPromoCode: (promoCode: string) => dispatch(addPromoCode(promoCode)),
        deletePromoCode: () => dispatch(deletePromoCode()),
        updateCartWithQuantityAvailable: (products: { idP: number, quantity: number }[]) => dispatch(updateCartWithQuantityAvailable(products)),
        resetCurrentOrderToStep1: () => dispatch(resetCurrentOrderToStep1())
    }
}

export default connect(mapState, mapDispatch)(Cart)
